import React from 'react';
import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import _ from 'lodash';
import { ENDPOINTS } from '../../../actions/Api/constants';

export const CompanyPeopleContext = React.createContext({
    companyId: undefined,
    people: [],
    isLoading: false
});

const CompanyPeopleProvider = ({ companyId, isLoading, people, children }) => {
    return (
        <CompanyPeopleContext.Provider value={{ companyId, people, isLoading }}>
            {children}
        </CompanyPeopleContext.Provider>
    );
};

const makeMapStateToProps = () => {
    const getState = createSelector(
        [
            state => _.get(state.loadingStates, `${ENDPOINTS.API.COMPANY}.isLoading`, false),
            (state, { companyId }) => state.people.filter(x => x.companyId === companyId)
        ],
        (isLoading, people) => ({
            isLoading,
            people
        })
    );
    return (state, props) => getState(state, props);
};

export default connect(makeMapStateToProps)(CompanyPeopleProvider);
